import { put, select } from 'redux-saga/effects';
import { actions as errorActions } from '../reducers/error';

export const getCurrentPath = state => state.router.location.pathname;
export const getPreviousLocation = state => state.myRouter.previousLocation;

export function* goErrorPage(args) {
  if (args) {
    const { payload } = args;
    const { handlingCode } = payload;
    const currentPath = yield select(getCurrentPath);
    if (handlingCode && handlingCode < 0) {
      yield put(errorActions.storeError({ handlingCode, currentPath }));
    }
  }
}
